import { Card, CardContent } from "@mui/material";
import { ReactNode } from "react";

import styles from "./styles.module.scss";

type Props = {
  title: string;
  children: ReactNode;
};

const PatientCardInfo = (props: Props) => {
  const { title, children } = props;
  
  return (
    <Card variant="outlined" className={`${styles.card} mg-b-10`}>
      <CardContent className={styles.cardContent}>
        <div className="d-flex align-items-center flex-wrap">
            <h6 className="heading6 mg-r-10">{title}</h6>
            {children}
        </div>
      </CardContent>
    </Card>
  );
};

export default PatientCardInfo;
